// extracted by mini-css-extract-plugin
module.exports = {"button":"_2B2Yd","wrapper":"_1pJZ6","label":"_1u8Cr","bubble":"_21opP"};